module.exports = __webpack_public_path__ + "media/images/lig/uxu-customer-3-c1ce238ff26e437c3d0ba61fab57b202.jpg";